import { TASK_TEXT } from './text'
import type { BuiltInTaskDefinition } from './types'

export const TEAM_DELETE_TASK: BuiltInTaskDefinition = {
    slug: 'team-delete',
    name: 'Delete a team from a conversation',
    kind: 'llm',
    overlapPolicy: 'skip',
    concurrencySafe: true,
    serializeOn: null,
    builtInRole: 'org_change',
    chatPurpose: null,
    goal: 'Name everything that references a team, write its deletion as a plan, and get the CEO’s sign-off; the OS deletes the team at their approval only while nobody is seated on it',
    metric: {
        text: 'Share of team-deletion sign-offs that name every reference before the CEO decides',
    },
    guardrails: [
        'Propose only — write the plan with os.write_plan; the OS deletes the team once the CEO approves, and refuses while any member is still seated on it',
        'Name every member, role and task that references the target before asking for sign-off',
        'An empty reference list is a real answer, but only after looking',
    ],
    inputs: [
        {
            key: 'request',
            label: 'What the CEO wants deleted',
            type: 'string',
            required: true,
        },
        {
            key: 'ceoNote',
            label: 'CEO note from a previous round',
            type: 'string',
            required: false,
        },
        {
            key: 'chatSessionId',
            label: 'Chat session this plan belongs to (chat fills it)',
            type: 'string',
            required: false,
        },
        {
            key: 'planKey',
            label: 'The conversation this plan belongs to when it has no chat session (the OS fills it)',
            type: 'string',
            required: false,
        },
    ],
    tools: ['os.directory', 'os.write_plan', 'os.read_plan', 'os.ask_ceo'],
    gates: [
        {
            tool: 'os.ask_ceo',
            owner: 'ceo',
            approval: 'specific',
        },
    ],
    spend: {
        moneyUsdPerRun: 1.5,
        maxModelTier: 'mid',
    },
    workspace: null,
    requiredWrites: null,
    allowSelfReaction: null,
    contextPrefixes: null,
    trainGrants: null,
    finishesOn: null,
    successors: [
        {
            slug: 'team-delete',
            on: 'ceo_approved',
            resumeConversation: true,
        },
        {
            slug: 'team-delete',
            on: 'ceo_changes_requested',
        },
        {
            slug: 'task-self-improvement',
            on: 'terminal',
        },
    ],
    skillMd: TASK_TEXT['team-delete.md'],
    adapterMd: TASK_TEXT['team-delete.adapter.md'],
}
